import React, { useEffect, useState } from "react";
import { Table, Tooltip, Col, Form, Input } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { URL } from "../../Redux/common/url";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";

function Shorts() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.get_blog ? state?.allapi?.get_blog : {}
  );

  console.log(users_list);

  const listdata = users_list?.docs ? users_list?.docs : [];

  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [showDelelt, setShowDelete] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    dispatch(allapiAction.shortsDelete({ id: e, page: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});

  console.log(cateDetail);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");
  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };
  const [aboutPageUpdate, setaboutPageUpdate] = useState("");
 const showModal = (e) => {
  setcateDetail(e);
  setaboutPageUpdate(e?.description);

  setImagesfe([{ data_url: URL.API_BASE_URL + e.feature_image }]);

  // ✅ ADD THIS
  setcateDetail({
    ...e,
    video_type: e?.video_type,
    video_link: e?.video_link,
  });

  setIsModalOpen(true);
};
 const handleOk = () => {
  const data = new FormData();

  data.append("title", cateDetail?.title);
  data.append("description", aboutPageUpdate);
  data.append("meta_description", cateDetail?.meta_description);
  data.append("short_description", cateDetail?.short_description);
  data.append("meta_title", cateDetail?.meta_title);

  // ✅ ADD THESE (important)
  data.append("video_type", cateDetail?.video_type);
  data.append("video_link", cateDetail?.video_link);

  data.append("_id", cateDetail?._id);
  data.append("page", page);

  if (Imagesfe[0]?.file) {
    data.append("feature_image", Imagesfe[0]?.file);
  }

  dispatch(allapiAction.shortsUpdate(data));
  setIsModalOpen(false);
};
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);

  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    setcateDetailAdd({ ...cateDetailAdd, [name]: value });
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };

  const [aboutPage, setaboutPage] = useState("");
  const handleOkAdd = async() => {
    if (!cateDetailAdd?.title) {
      toast.error("please enter title");
    } else {
      const data = new FormData();
      data.append("page", 1);
      data.append("title", cateDetailAdd?.title);
      data.append("description", aboutPage);
      data.append("meta_title", cateDetailAdd?.meta_title);
      data.append("meta_description", cateDetailAdd?.meta_description);
      data.append("short_description", cateDetailAdd?.short_description);
       data.append("video_type", cateDetailAdd?.video_type);
         data.append("video_link", cateDetailAdd?.video_link);
      //   data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append('categoryName', 'test cate')
      //   data.append("parentId", "11");
      //   data.append("sellerId", "20");
      data.append("feature_image", images[0]?.file);

    await  dispatch(allapiAction.createShorts(data));
        dispatch(allapiAction.shortsList(1));

      setcateDetailAdd({ name: "", link: "" });
      // dispatch(adminAction.getRoleList('dhsg'))
      setAddModalOpen(false);
      return () => {};
    }
  };

  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    // dispatch(allapiAction.statusBrands({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "100px" }}>
              <img
                style={{ width: "100%" }}
                src={URL?.API_BASE_URL + item?.feature_image}
                alt=""
              />
            </div>
          </>
        );
      },
    },
    {
  title: "Video",
  key: "video",
  render: (_, item) => {
    if (!item?.video_link) return "No Video";

    let videoUrl = item.video_link;

    // YouTube fix
    if (videoUrl.includes("watch?v=")) {
      videoUrl = videoUrl.replace("watch?v=", "embed/");
    }

    if (videoUrl.includes("shorts")) {
      videoUrl = videoUrl.replace("/shorts/", "/embed/");
    }

    return (
      <iframe
        width="120"
        height="200"
        src={videoUrl}
        title="video"
        frameBorder="0"
        allowFullScreen
      />
    );
  },
},
    {
  title: "Video",
  dataIndex: "video_link",
  key: "video_link",
  render: (value) => {
    if (!value) return "No Video";

    return (
      <a href={value} target="_blank" rel="noreferrer">
        View Video
      </a>
    );
  },
},
    {
      title: "Short description",
      dataIndex: "short_description",
      key: "short_description",
    },
  
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.is_status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.is_status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.is_status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(allapiAction.shortsList(1));

    return () => {};
  }, []);

  // const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);
    if (e) {
      dispatch(allapiAction.allcategorySearch({ page: 1, search: e }));
      return () => {};
    } else {
      dispatch(allapiAction.shortsList(1));

      return () => {};
    }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    if (search) {
      dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
      return () => {};
    } else {
      dispatch(allapiAction.shortsList(e));

      return () => {};
    }
  };

  const API_URl = URL.API_BASE_URL;
  const UPLOAD_ENDPOINT = "publicApi/productcon";

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("upload", file);
            fetch(`${API_URl}/${UPLOAD_ENDPOINT}`, {
              method: "post",
              body: body,
            })
              .then((res) => res.json())
              .then((res) => {
                // console.log(res);
                resolve({ default: `${res.url}` });
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <div>
      {/* update */}
    <Modal
  title="Update Video"
  open={isModalOpen}
  onOk={handleOk}
  onCancel={handleCancel}
>
  {/* Image Upload */}
  <Col span={24}>
    <ImageUploading
      value={Imagesfe}
      onChange={onChangefe}
      maxNumber={1}
      dataURLKey="data_url"
      acceptType={["png", "jpeg", "jpg", "webp"]}
    >
      {({ imageList, onImageUpload, onImageRemoveAll, onImageUpdate, onImageRemove }) => (
        <div className="upload__image-wrapper">
          <button onClick={onImageUpload} className="btn btn-secondary">
            Choose image
          </button>
          <button onClick={onImageRemoveAll} className="btn btn-secondary">
            Remove all
          </button>

          {imageList.map((image, index) => (
            <div key={index}>
              <img src={image.data_url} alt="" width="100" />
              <div>
                <button onClick={() => onImageUpdate(index)}>Update</button>
                <button onClick={() => onImageRemove(index)}>Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </ImageUploading>
  </Col>

  {/* Title */}
  <Col span={24}>
    <input
      className="form-control mt-3"
      placeholder="Title"
      name="title"
      value={cateDetail?.title}
      onChange={hendleTochangeCategory}
    />
  </Col>

  {/* Short Description */}
  <Col span={24}>
    <input
      className="form-control mt-3"
      placeholder="Short description"
      name="short_description"
      value={cateDetail?.short_description}
      onChange={hendleTochangeCategory}
    />
  </Col>

  {/* Video Type */}
  <Col span={24}>
    <select
      className="form-control mt-3"
      name="video_type"
      value={cateDetail?.video_type || ""}
      onChange={hendleTochangeCategory}
    >
      <option value="">Select Video Type</option>
      <option value="fullvideo">Full Video</option>
      <option value="shortvideo">Short Video</option>
    </select>
  </Col>

  {/* Video Link */}
  <Col span={24}>
    <input
      className="form-control mt-3"
      placeholder="Video link"
      name="video_link"
      value={cateDetail?.video_link || ""}
      onChange={hendleTochangeCategory}
    />
  </Col>

  {/* 🔥 Live Preview */}
  {cateDetail?.video_link && (
    <Col span={24} className="mt-3">
      <iframe
        width="100%"
        height="250"
        src={
          cateDetail.video_link
            ?.replace("watch?v=", "embed/")
            ?.replace("/shorts/", "/embed/")
        }
        title="preview"
        frameBorder="0"
        allowFullScreen
      />
    </Col>
  )}

  {/* Meta Title */}
  <Col span={24}>
    <input
      className="form-control mt-3"
      placeholder="Meta title"
      name="meta_title"
      value={cateDetail?.meta_title}
      onChange={hendleTochangeCategory}
    />
  </Col>

  {/* Meta Description */}
  <Col span={24}>
    <input
      className="form-control mt-3"
      placeholder="Meta description"
      name="meta_description"
      value={cateDetail?.meta_description}
      onChange={hendleTochangeCategory}
    />
  </Col>

  {/* Description */}
  <Col span={24} className="mt-3">
    <CKEditor
      editor={Editor}
      data={aboutPageUpdate}
      onChange={(event, editor) => {
        const data = editor.getData();
        setaboutPageUpdate(data);
      }}
      config={{ extraPlugins: [uploadPlugin] }}
    />
  </Col>
</Modal>

      {/* create */}
   <Modal
  title="Create Video"
  open={addModalOpen}
  onOk={handleOkAdd}
  onCancel={handleCancelAdd}
>
  {/* Image Upload */}
  <div className="mb-3">
    <ImageUploading
      value={images}
      onChange={onChange}
      maxNumber={1}
      dataURLKey="data_url"
      acceptType={["png", "jpeg", "jpg", "webp"]}
    >
      {({ imageList, onImageUpload, onImageRemoveAll }) => (
        <div>
          <button onClick={onImageUpload} className="btn btn-primary">
            Upload Image
          </button>

          {imageList.length > 0 && (
            <button
              className="btn btn-danger ms-2"
              onClick={onImageRemoveAll}
            >
              Remove
            </button>
          )}

          {imageList.map((image, index) => (
            <div key={index} className="mt-2">
              <img src={image.data_url} width="100" alt="" />
            </div>
          ))}
        </div>
      )}
    </ImageUploading>
  </div>

  {/* Title */}
  <input
    className="form-control mb-3"
    placeholder="Title"
    name="title"
    value={cateDetailAdd?.title || ""}
    onChange={hendleTochangeCategoryAdd}
  />

  {/* Short Description */}
  <input
    className="form-control mb-3"
    placeholder="Short Description"
    name="short_description"
    value={cateDetailAdd?.short_description || ""}
    onChange={hendleTochangeCategoryAdd}
  />

  {/* Video Type */}
  <select
    className="form-control mb-3"
    name="video_type"
    value={cateDetailAdd?.video_type || ""}
    onChange={hendleTochangeCategoryAdd}
  >
    <option value="">Select Video Type</option>
    <option value="fullvideo">Full Video</option>
    <option value="shortvideo">Short Video</option>
  </select>

  {/* Video Link */}
  <input
    className="form-control mb-2"
    placeholder="Enter YouTube Link"
    name="video_link"
    value={cateDetailAdd?.video_link || ""}
    onChange={hendleTochangeCategoryAdd}
  />

  {/* 🔥 Video Preview */}
  {cateDetailAdd?.video_link && (
    <div className="mt-3">
      <label className="mb-2 fw-bold">Preview:</label>

      {(() => {
        let videoUrl = cateDetailAdd.video_link;

        if (videoUrl.includes("watch?v=")) {
          videoUrl = videoUrl.replace("watch?v=", "embed/");
        }

        if (videoUrl.includes("/shorts/")) {
          videoUrl = videoUrl.replace("/shorts/", "/embed/");
        }

        return (
          <iframe
            width="100%"
            height="250"
            src={videoUrl}
            title="Video Preview"
            frameBorder="0"
            allowFullScreen
          />
        );
      })()}
    </div>
  )}

  {/* Description Editor */}
  <div className="mt-3">
    <CKEditor
      editor={Editor}
      data={aboutPage}
      onChange={(event, editor) => {
        setaboutPage(editor.getData());
      }}
      config={{
        extraPlugins: [uploadPlugin],
      }}
    />
  </div>
</Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"Video"}
            subHeading={`Total ${users_list?.totalDocs || 0} Video`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: users_list?.totalDocs ? users_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Shorts;
